<template>
  <div
    class="flex items-center gap-3 p-4 bg-white rounded-lg border text-black border-[#5C5C5C2E]"
  >
    <div class="flex-shrink-0 size-12" aria-hidden="true">
      <svg
        width="100%"
        height="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 24C0 10.745 10.745 0 24 0s24 10.745 24 24-10.745 24-24 24S0 37.255 0 24Z"
          fill="#EC0F03"
        />
        <path
          d="M33.973 30.686a11.565 11.565 0 0 0-5.698-4.99 7.124 7.124 0 1 0-8.55 0 11.565 11.565 0 0 0-5.698 4.99 1.126 1.126 0 0 0 1.264 1.676 1.123 1.123 0 0 0 .683-.55c1.699-2.937 4.699-4.688 8.026-4.688s6.327 1.752 8.026 4.687a1.125 1.125 0 0 0 1.947-1.125ZM19.125 20a4.875 4.875 0 1 1 9.75 0 4.875 4.875 0 0 1-9.75 0Z"
          fill="#fff"
        />
      </svg>
    </div>
    <div class="min-w-0 flex-1">
      <div class="text-lg font-semibold">
        <slot name="name"></slot>
      </div>
      <div class="text-[#161616A6] text-xs">
        <slot name="email"></slot>
      </div>
    </div>
  </div>
</template>
